module.exports = __webpack_public_path__ + "img/2.db19e8e8.jpg";